import { Component, inject } from "@angular/core"
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
} from "@angular/material/dialog"

export interface ConfirmDialogData {
    header: string
    message?: string
    confirmText?: string
    cancelText?: string
}

@Component({
    selector: "valben-confirm-dialog",
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose],
    template: `
        <h2 mat-dialog-title class="text-lg font-semibold">{{ data.header }}</h2>
        <mat-dialog-content>
            @if (data.message) {
                <p class="text-base">{{ data.message }}</p>
            }
        </mat-dialog-content>
        <mat-dialog-actions class="flex gap-4 justify-center items-center select-none">
            <button class="valben-button text-lg" [mat-dialog-close]="true">{{ data.confirmText ?? "Da" }}</button>
            <button class="valben-button text-lg" [mat-dialog-close]="false">{{ data.cancelText ?? "Ne" }}</button>
        </mat-dialog-actions>
    `,
})
export class ConfirmDialogComponent {
    data = inject<ConfirmDialogData>(MAT_DIALOG_DATA)
}
